export const StripWidth = 30;
export const DefaultStripSpace = StripWidth + 30;
export const CategoryDelimiterSize = 20;